import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ContextMenuService } from "../../../../services/context-menu.service";
import { PayLinksModelDto } from "../../models/paylinks.model";

@Component({
	selector: "app-paylink-context-menu",
	templateUrl: "./paylink-context-menu.component.html",
	styleUrls: ["./paylink-context-menu.component.scss"],
})
export class PaylinkContextMenuComponent {
	@Input() token: string | undefined;
	@Input() isUsed = true;
	@Input() configMenu: string | undefined;
	@Input() item?: PayLinksModelDto;
	@Output() openEditModal: EventEmitter<string> = new EventEmitter<string>();
	@Output() openDeleteModal: EventEmitter<string> = new EventEmitter<string>();
	@Output() openSendMailModal: EventEmitter<string> = new EventEmitter<string>();
	@Output() copyPaylinkEvent: EventEmitter<string> = new EventEmitter<string>();
	@Output() copyQrEvent: EventEmitter<string> = new EventEmitter<string>();
	@Output() openPaymentHistoryEvent: EventEmitter<string> = new EventEmitter<string>();

	// "PAY_LINK": "Оплата по ссылке",
	// "QR_PAY": "Оплата по QR",
	// "BOTH_PAY": "Оплата по ссылке и QR",

	constructor(private contextMenuService: ContextMenuService) {}

	editPaylink() {
		this.openEditModal.emit(this.token);
		this.contextMenuService.statusMenu$.next(false);
	}

	deletePaylink() {
		this.openDeleteModal.emit(this.token);
		this.contextMenuService.statusMenu$.next(false);
	}

	sendMailPaylink() {
		this.openSendMailModal.emit(this.token);
		this.contextMenuService.statusMenu$.next(false);
	}

	copyPaylink() {
		this.copyPaylinkEvent.emit(this.token);
		this.contextMenuService.statusMenu$.next(false);
	}

	copyQr() {
		this.copyQrEvent.emit(this.token);
		this.contextMenuService.statusMenu$.next(false);
	}

	openPaymentHistory() {
		this.openPaymentHistoryEvent.emit(this.token);
		this.contextMenuService.statusMenu$.next(false);
	}
}
